import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { TextField, FormControlLabel, Checkbox, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { ButtonSpinnerSlot } from '../ui/ButtonSpinner';
import { FixedSizeList as List } from 'react-window';

export default function Questionsdialog({ open, handleClose, questions, trainingId }) {
    const [editedContent, setEditedContent] = useState([]);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (questions && questions.length > 0) {
            setEditedContent([...questions]);
        }
    }, [questions]);

    const handleContentChange = (e, index, field) => {
        const updatedContent = [...editedContent];
        if (field === 'question') {
            updatedContent[index].question = e.target.value;
        } else {
            updatedContent[index][field] = e.target.value;
        }
        setEditedContent(updatedContent);
    };

    const handleOptionChange = (e, index, optionIndex) => {
        const updatedContent = [...editedContent];
        updatedContent[index].answer[optionIndex].answer = e.target.value;
        setEditedContent(updatedContent);
    };
    const getBasicAuthHeader = () => {
        const username = process.env.REACT_APP_API_USERNAME;
        const password = process.env.REACT_APP_API_PASSWORD;
        const encodedCredentials = btoa(`${username}:${password}`);
        return `Basic ${encodedCredentials}`;
      };

    const handleSave = async () => {
        //console.log(editedContent)
        setSaving(true); // Set saving to true when starting the save operation
        const apiUrl = process.env.REACT_APP_API_URL;
        try {
            const response = await fetch(apiUrl + `/api/generate_trainingquestion/${trainingId}`, {
                method: 'POST',
                headers: {
                 'Content-Type': "application/json",
            "Accept": "*/*",
            "Access-Control-Allow-Origin": "*",
            'Authorization': getBasicAuthHeader(),
                },
                body: JSON.stringify(editedContent), // Sending the edited content as the request body
            });
    
            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`);
            }
    
            const data = await response.text(); // Process the response if needed
            //console.log('Save Success:', data);
        } catch (error) {
            //console.error("Save Error:", error);
        } finally {
            setSaving(false); // Set saving to false after the save operation completes
            handleClose();
        }
    };
    

    async function getImageInFromDalle3(prompt, index, setLoading) {
        setLoading(true);
        try {
            const response = await dalle3Api(prompt);
            if (response.ok) {
                const responseData = await response.json();
                const imageUrl = responseData?.data?.[0]?.url || "";
                const updatedContent = [...editedContent];
                updatedContent[index].asset = imageUrl;
                setEditedContent(updatedContent);
            } else {
                //console.error('Error: Unexpected response:', response.status, response.statusText);
                throw new Error('Unexpected response');
            }
        } catch (error) {
            //console.error('Error:', error);
            throw error;
        } finally {
            setLoading(false);
        }
    }

    async function dalle3Api(prompt) {
        const apiUrl1 = process.env.REACT_APP_API_URL1;
        const token = localStorage.getItem('token');
        const response = await fetch(apiUrl1 + "/api/generate_image", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token,
                'Accept-Encoding': 'gzip, deflate, br',
                'Accept': '/',
                'Connection': 'keep-alive',
          "X-Api-Version": 'v2'
            },
            body: JSON.stringify({
                'model': 'dall-e-3',
                'prompt': prompt,
                'n': 1,
                'size': '1024x1024',
                test_id: trainingId
            }),
        });

        return response;
    }

    useEffect(() => {
        editedContent.forEach((question, index) => {
            if (question.prompt && !question.asset) {
                getImageInFromDalle3(question.prompt, index, setLoading);
            }
        });
    }, [editedContent]);

    const renderQuestion = ({ index, style }) => {
        const question = editedContent[index];
        return (
            <div key={index} style={{ ...style, marginBottom: '20px', display: 'flex', alignItems: 'flex-start' }}>
                <div style={{ flex: 1, marginRight: '20px' }}>
                    <TextField
                        value={question.question}
                        onChange={(e) => handleContentChange(e, index, 'question')}
                        variant="outlined"
                        fullWidth
                        multiline
                        label={`Question ${index + 1}`}
                        style={{ marginBottom: '20px' }}
                    />
                    <Typography variant="body1">Answers:</Typography>
                    {question.answer.map((option, optionIndex) => (
                        <div key={optionIndex}>
                            <FormControlLabel
                                control={<Checkbox checked={option.is_correct === 1} />}
                                label={
                                    <TextField
                                        value={option.answer}
                                        onChange={(e) => handleOptionChange(e, index, optionIndex)}
                                        variant="outlined"
                                        fullWidth
                                        multiline
                                        label={`Option ${optionIndex + 1}`}
                                        style={{ margin: '10px' }}
                                    />
                                }
                            />
                        </div>
                    ))}
                    <TextField
                        value={question.keywords}
                        onChange={(e) => handleContentChange(e, index, 'keywords')}
                        variant="outlined"
                        fullWidth
                        multiline
                        label="Keywords"
                        style={{ marginTop: '10px', marginBottom: '10px' }}
                    />
                    <TextField
                        value={question.hint}
                        onChange={(e) => handleContentChange(e, index, 'hint')}
                        variant="outlined"
                        fullWidth
                        multiline
                        label="Hint"
                        style={{ marginBottom: '10px' }}
                    />
                    <TextField
                        value={question.explanation}
                        onChange={(e) => handleContentChange(e, index, 'explanation')}
                        variant="outlined"
                        fullWidth
                        multiline
                        label="Explanation"
                        style={{ marginBottom: '20px' }}
                    />
                    <br></br>
                </div>
                {loading ? (
                    <CircularProgress />
                ) : question.asset && (
                    <img
                        src={question.asset}
                        alt={`Question ${index + 1}`}
                        style={{ width: '200px', height: '200px', borderRadius: '8px' }}
                    />
                )}
            </div>
        );
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle>Generated Questions</DialogTitle>
            <DialogContent>
                <List
                    height={600} // Adjust the height as needed
                    itemCount={editedContent.length}
                    itemSize={600} // Adjust the height of each item as needed
                    width="100%"
                >
                    {renderQuestion}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary" autoFocus>
                    Close
                </Button>
                <Button onClick={handleSave} color="primary">
                    {saving ? <ButtonSpinnerSlot size={24} /> : "Save"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
